<svelte:head>
    <script type="text/javascript" src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"></script>
</svelte:head>

<div class="cluedle-promo">
    <div class="cluedle-promo-inner">
        <h1>Join the Cluedle community</h1>
        <h3>The easiest way to learn and perfect your cryptic clue skills</h3>
        
        <p>📥 We send you a <strong>new clue</strong> every morning</p>
        <p>🔥 We start off <strong>easy on Mondays</strong> and the clues gradually get harder until the <strong>Sunday Sizzler</strong> </p>
        <!-- <p>🥳 
            Cluedle is the easiest and most fun way to get started with cryptic crosswords. And the harder clues will challenge even more experienced solvers.
        </p> -->
        <p>📚 if you get stuck we have a <strong>guide</strong> to walk you through the different types of clues and the <strong>best way to solve them</strong> </p>
        <p>Also, get invites to our <strong>cryptic events</strong>, the <strong>Cluedle discussion board</strong>, and a chance to <strong>test your clue-setting skills</strong></p>
        <div class="promo-form">
            <form class="js-cm-form" id="subForm" action="https://www.createsend.com/t/subscribeerror?description=" method="post" data-id="92D4C54F0FEC16E5ADC2B1904DE9ED1A27514B90F079AE0661031240550D40CE9B9901FA8AAE89B97247191F2913E73692270C442CE87FF8F40DA1A162D458F1"><input autocomplete="Email" aria-label="Email" class="js-cm-email-input qa-input-email" id="fieldEmail" maxlength="200" name="cm-tlkjdtu-tlkjdtu" placeholder="Email Address" required="" type="email">
                <input type="hidden" value="Cluedle" aria-label="Signup source" id="fieldtrhllky" maxlength="200" name="cm-f-trhllky"><input type="hidden" value="Facebook" aria-label="Origin" id="fieldttolhi" maxlength="200" name="cm-f-ttolhi"><input type="hidden" value="Paid Social" aria-label="Origin type" id="fieldttolhd" maxlength="200" name="cm-f-ttolhd"><button type="submit">Join</button></form>
        </div>
    </div>
<div class="promo-disclaimer">
    Joining is <strong>free</strong>. We will <strong>never share your email address</strong> with anyone else. You can <strong>unsubscribe at any time</strong>.
    <p><a href="https://cluedle.theoutlier.co.za">Let me play first</a></p>
</div>

</div>


<style>
.cluedle-promo {
    /* font-size: 1.5rem; */
    /* font-weight: 600; */
    color: #000;
    text-align: center;
    padding:3rem;
    padding-top: 1rem;
    
    border-radius: 3px;
    margin: 1rem;
    width: calc(80% - 3rem); 
    max-width: 800px;
    margin:auto;
    margin-right: auto;
    margin-top: 10px;
    /* background-image: linear-gradient(rgb(0, 191, 255), rgb(118, 195, 244)); */
    background: #fff;
    border: solid 1px lightgray;
    padding-bottom: 50px;
    
}

.cluedle-promo p { 
    text-align: left;
}
.cluedle-promo-inner { 
    max-width: 600px; 
    margin-left: auto;
    margin-right: auto;
    line-height: 1.4;
}
.cluedle-promo h3 { 
    font-weight: 400;
    color: gray;
}
.cluedle-promo h1 { 
    font-size: 2.5rem;
    font-weight: 900;
    line-height: 1;
    color: #DA1A18;
}
@media only screen and (max-width: 800px) {
.cluedle-promo-inner { 
    font-size: 0.8rem;
    overflow-y: scroll;
    max-height: 100vh;
    line-height: 1.2;
    /* padding: 5px; */
    /* margin-bottom: 100px; */
}
.cluedle-promo h1 { 
    font-size: 1.5rem;
    font-weight: 900;
    line-height: 1;
    color: #DA1A18;
}
.promo-disclaimer { 
    padding-bottom: 50px;
}
}



@media only screen and (max-width: 800px) {
.cluedle-promo { 
    font-size: 0.9rem;
}
}
.promo-form { 
    margin-top: 30px;
}
.promo-form button { 
    background: var(--primary-color);
    color: #fff;
    border-radius: 3px;
    padding: 10px;
    width: 150px;
    
}
.promo-form input { 
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
    pointer-events: all;
}
.promo-form button:hover { 
    filter: brightness(1.1);
}
.promo-disclaimer { 
    margin-top: 30px;
    font-size: 0.9rem;
}
.promo-disclaimer strong { 
    font-weight: 600;
    color: var(--primary-color);
    /* background: var(--primary-color); */
}
.promo-disclaimer p { 
    width: 100%; 
    text-align: center;
}
.promo-disclaimer a { 
    color: gray;
    text-decoration: none;
}
@media only screen and (max-width: 800px) {
.promo-disclaimer a { 
    font-size: 0.7rem;
}
}
</style>